/**
 * @generated SignedSource<<fb2be838b4f9992f485f319ede110e55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyType = "ClientCompany" | "PartnerCompany" | "SuperCompany";
export type DistanceUnit = "km" | "mi";
export type LanguageEnum = "en";
export type useCurrentUserQuery$variables = Record<PropertyKey, never>;
export type useCurrentUserQuery$data = {
  readonly viewer: {
    readonly accessibleCompanies?: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
    }> | null;
    readonly company?: {
      readonly clientCode: string | null;
      readonly distanceUnit: DistanceUnit;
      readonly id: string;
      readonly inHouse: boolean | null;
      readonly language: LanguageEnum;
      readonly name: string | null;
      readonly resourcesUrl: string | null;
      readonly swcid: number;
      readonly type: CompanyType;
      readonly " $fragmentSpreads": FragmentRefs<"useClientAttributesFragment" | "useCompanyInfo_company">;
    } | null;
    readonly ctiStatus?: {
      readonly extension: string | null;
      readonly id: string;
      readonly status: string;
    } | null;
    readonly email?: string | null;
    readonly firstName?: string | null;
    readonly id?: string;
    readonly language?: string;
    readonly name?: string | null;
    readonly permissions?: {
      readonly isAdmin: boolean;
      readonly isAnsweringService: boolean;
      readonly isClient: boolean;
      readonly isClientAdjuster: boolean;
      readonly isClientReadOnly: boolean;
      readonly isCommunicationsIntegrationEnabled: boolean;
      readonly isCtiEnabled: boolean;
      readonly isDispatcher: boolean;
      readonly isDriver: boolean;
      readonly isInsightsEnabled: boolean;
      readonly isPartner: boolean;
      readonly isRoot: boolean;
      readonly isSuperCompany: boolean;
      readonly isSwoopDispatcher: boolean;
    };
    readonly roles?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
    } | null;
    readonly swcid?: number | null;
    readonly timezone?: string | null;
    readonly userName?: string | null;
  };
};
export type useCurrentUserQuery = {
  response: useCurrentUserQuery$data;
  variables: useCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "swcid",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "accessibleCompanies",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distanceUnit",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcesUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inHouse",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CTIAgentStatusType",
  "kind": "LinkedField",
  "name": "ctiStatus",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPermission",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRoot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDriver",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDispatcher",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnsweringService",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPartner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isClientAdjuster",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isClientReadOnly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuperCompany",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSwoopDispatcher",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCtiEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInsightsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCommunicationsIntegrationEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "RoleConnection",
  "kind": "LinkedField",
  "name": "roles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  (v0/*: any*/)
],
v19 = [
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useCompanyInfo_company"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useClientAttributesFragment"
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v9/*: any*/),
              (v2/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Location",
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lng",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "pastEtaColor",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "past_eta"
                      }
                    ],
                    "concreteType": "Setting",
                    "kind": "LinkedField",
                    "name": "setting",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": "setting(name:\"past_eta\")"
                  },
                  {
                    "alias": "etaApproachingColor",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "eta_approaching"
                      }
                    ],
                    "concreteType": "Setting",
                    "kind": "LinkedField",
                    "name": "setting",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": "setting(name:\"eta_approaching\")"
                  },
                  {
                    "alias": "enRouteColor",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "en_route"
                      }
                    ],
                    "concreteType": "Setting",
                    "kind": "LinkedField",
                    "name": "setting",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": "setting(name:\"en_route\")"
                  },
                  {
                    "alias": "clientChatEnabled",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "ClientChat"
                      }
                    ],
                    "concreteType": "Feature",
                    "kind": "LinkedField",
                    "name": "feature",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "feature(name:\"ClientChat\")"
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v9/*: any*/),
              (v2/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v19/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          },
          {
            "kind": "InlineFragment",
            "selections": (v19/*: any*/),
            "type": "Application",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bda321aeb1e38c8b0987f61bd0feb1c9",
    "id": null,
    "metadata": {},
    "name": "useCurrentUserQuery",
    "operationKind": "query",
    "text": "query useCurrentUserQuery {\n  viewer {\n    __typename\n    ... on User {\n      id\n      swcid\n      accessibleCompanies {\n        id\n        name\n      }\n      company {\n        id\n        clientCode\n        swcid\n        distanceUnit\n        resourcesUrl\n        inHouse\n        language\n        name\n        type\n        ...useCompanyInfo_company\n        ...useClientAttributesFragment\n      }\n      email\n      ctiStatus {\n        id\n        extension\n        status\n      }\n      language\n      name\n      firstName\n      permissions {\n        isRoot\n        isDriver\n        isAdmin\n        isDispatcher\n        isAnsweringService\n        isPartner\n        isClient\n        isClientAdjuster\n        isClientReadOnly\n        isSuperCompany\n        isSwoopDispatcher\n        isCtiEnabled\n        isInsightsEnabled\n        isCommunicationsIntegrationEnabled\n      }\n      roles {\n        nodes {\n          id\n          name\n        }\n      }\n      timezone\n      userName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Application {\n      id\n    }\n  }\n}\n\nfragment Countdown_company on Company {\n  pastEtaColor: setting(name: past_eta) {\n    value\n    id\n  }\n  etaApproachingColor: setting(name: eta_approaching) {\n    value\n    id\n  }\n  enRouteColor: setting(name: en_route) {\n    value\n    id\n  }\n}\n\nfragment useClientAttributesFragment on Company {\n  clientChatEnabled: feature(name: ClientChat) {\n    id\n  }\n}\n\nfragment useCompanyInfo_company on Company {\n  logoUrl\n  name\n  location {\n    lat\n    lng\n    id\n  }\n  ...Countdown_company\n}\n"
  }
};
})();

(node as any).hash = "a89248c9e4dbdf56d467011db53faccc";

export default node;
